import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { catchError, map, mergeMap, Observable, of, tap, throwError, timer } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService,private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getToken();
    const customerId = this.authService.getCustomer();
    if (token && customerId) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          CustomerId: customerId
        }
      });
    } else if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        // Checks if the response status code is between 200 and 299
        if (event instanceof HttpResponse && event.status < 300) {
          // Continues the process normally
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          return timer(50).pipe(
            mergeMap(() => {
              return this.authService.refreshToken(token).pipe(
                mergeMap(newToken => {
                  if (newToken) {
                    // Clone the original request with the new token
                    const newRequest = request.clone({
                      setHeaders: {
                        Authorization: `Bearer ${newToken}`
                      }
                    });
                    // Return the new request to continue the HTTP flow
                    return next.handle(newRequest);
                  } else {
                    // If no new token, log out the user
                    this.authService.logout("expired");
                    return throwError(error);
                  }
                }),
                catchError(() => {
                  // Handle refresh token failure and log out the user
                  this.authService.logout("expired");
                  return throwError(error);
                })
              );
            })
          );
        } else if (error.status === 403) {
          // Redirect to home and reload page on 403 error
          this.router.navigate(['/']).then(() => {
            window.location.reload();
          });
        }
        // Rethrow the error if not handled
        return throwError(error);
      })
    );

  }
}
